import React, { useEffect, useState } from 'react'
import { toast, ToastContainer } from "react-toastify";

import "common/css/master.css";
import { savePanelSvc } from './panelSvc';


function PanelSlider(props) {
  const { panelDtls, deletePanel, closeSlider, updateKey } = props;

  const [editLoader, setEditLoader] = useState("none");
  const [editOpacity, setEditOpacity] = useState(1);
  const [panelId, setPanelId] = useState(0);
  const [panel, setPanel] = useState("");
  const [location, setLocation] = useState("");
  const [layoutTypeId, setLayoutTypeId] = useState(10);

  useEffect(() => {
    // console.log("PanelSlider called");
    if (panelDtls && Object.keys(panelDtls).length > 0) {
      setPanel(panelDtls.panel);
      setPanelId(panelDtls.panelId);
      setLocation(panelDtls.location);
      setLayoutTypeId(panelDtls.layoutTypeId);
    }
  }, [panelDtls]);

  const savePanel = () => {
    // console.log("savePanel called");
    setEditLoader("block");
    setEditOpacity(0.5);
    const panelObj = {
      panelId,
      panel,
      location,
      layoutTypeId
    }
    savePanelSvc(panelObj, savePanelResponse);
  }



  const savePanelResponse = (data) => {
    // console.log("savePanelResponse called, data", data);
    if (data.status === "Success") {
      toast.success(data.message);
      setPanelId(data.panelId);
      updateKey();
    } else if (data.status === "Failure") {
      handleServiceError(data.message);
    } else {
      toast.error("Service failed " + data.error);
    }
    setEditLoader("none");
    setEditOpacity(1);
  }

  const handleServiceError = (svcMsg) => {
    if (svcMsg === "You are not Logged In") {
      toast.error("You are not logged in. Redirecting to login page...");
      setTimeout(() => {
        window.location.href = "/";
      }, 2000);
    } else if (svcMsg === "Server Timed Out, Login Again") {
      toast.error("Server timed out. Redirecting to login page...");
      setTimeout(() => {
        window.location.href = "/";
      }, 2000);
    } else {
      toast.error(svcMsg);
    }
  };

  return (
    <div >
      <button type="button" className='btn btn-info text-center btnCloseDiv' onClick={() => closeSlider()} style={{ right: "60%" }}>
        <span id="close" title="Close Slider" className="glyphicon glyphicon-remove"></span>
      </button>
      <div style={{ position: 'fixed', zIndex: 10000, width: 100, height: 100, marginLeft: -50, marginTop: -50, left: '58%', top: '45%', display: editLoader }}>
        <img className="loderImg" src={require("common/images/loader.gif")} alt="Loader..." />
      </div>
      <div className="col-md-12 col-xs-12 col-centered padding-remove "
        style={{
          cursor: (editLoader === "none") ? 'pointer' : 'none',
          pointerEvents: (editLoader === "none") ? 'auto' : 'none',
          opacity: editOpacity
        }}>
        <div className="col-sm-12 col-md-12 padding-remove"
          style={{ width: '94%', margin: '3% ', background: '#fff', border: '1px solid #ccc', borderRadius: 10 }}>
          <form
            id="editContentForm"
            className='form form-horizontal'
            style={{ height: "80vh", maxHeight: "600px", overflowX: 'hidden', padding: "20px 20px 5px 20px", }}
          >
            <div className="form-group col-md-12 " style={{ padding: "5px 0" }}>
              <div className="form-group col-md-12 padding-remove">
                <label className="control-label col-md-4 col-xs-6 " style={{ padding: "7px 0 0 0" }}>
                  Panel:
                </label>
                <div className='col-md-6 col-sm-6 col-xs-12  '>
                  <input
                    type="text"
                    className="form-control"
                    minLength={5}
                    maxLength={20}
                    value={panel}
                    onChange={(e) => setPanel(e.target.value)}
                    placeholder='E.g. Reception'
                  ></input>
                </div>
              </div>
              <div className="form-group col-md-12 padding-remove">
                <label className="control-label col-md-4 col-xs-6 " style={{ padding: "7px 0 0 0" }}>
                  Location:
                </label>
                <div className='col-md-6 col-sm-6 col-xs-12  '>
                  <input
                    type="text"
                    className="form-control"
                    minLength={5}
                    maxLength={20}
                    value={location}
                    onChange={(e) => setLocation(e.target.value)}
                    placeholder='E.g. Reception'
                  ></input>
                </div>
              </div>
              <div className="form-group col-md-12 padding-remove">
                <label className="control-label col-md-4 col-xs-6 " style={{ padding: "12px 0 0 0" }}>
                  Layout:
                </label>
                <div className="col-md-8 col-sm-8 col-xs-12" style={{ display: "flex", alignItems: "center" }}>
                  <div className="radio" style={{ marginRight: "15px" }}>
                    <label>
                      <input
                        type="radio"
                        name="orientation"
                        value="10"
                        checked={layoutTypeId === 10}
                        onChange={() => setLayoutTypeId(10)}
                      />
                      Landscape
                    </label>
                  </div>
                  <div className="radio">
                    <label>
                      <input
                        type="radio"
                        name="orientation"
                        value="20"
                        checked={layoutTypeId === 20}
                        onChange={() => setLayoutTypeId(20)}
                      />
                      Portrait
                    </label>
                  </div>
                </div>
              </div>
              <div className='col-sm-10   padding-remove' style={{ height: "50px", marginTop: "30px" }}>
                <div className="col-sm-4 col-md-4  padding-remove pull-right">
                  <div className="col-sm-6 col-md-6  ">
                    <button type="button" className="btn btn-info " onClick={() => savePanel()} >Save</button>
                  </div>
                  <div className="col-sm-6 col-md-6  ">
                    <button type="button" className="btn btn-info " onClick={() => deletePanel()} >Delete</button>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div >
    </div >
  )
}

export default PanelSlider